import ReactGA from "react-ga4";
import { getAttributeKey } from "../utils/storage";

const GA_MEASUREMENT_ID = "G-6LCM82QZPW";

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

// Gtag Tracking Event
export const trackEvent = ({ action, category, label, value }) => {
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// Analytics Events
export const analyticsEvent = (data) => {
  if (typeof window.gtag !== "function") return;

  const { event_name, ...params } = data;

  window.gtag("event", event_name ?? "undefined_event", params);
};

// User Attributes
export const setUserAttributes = (attributes) => {
  if (typeof window.gtag !== "function") return;

  const finalAttributes = {
    ...attributes,
    attribute_key: getAttributeKey() || "",
  };

  window.gtag("set", "user_properties", finalAttributes);
};
